export enum IconSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  EXTRA_LARGE = 'extra-large'
}

export enum IconColor {
  LIGHT = 'light',
  DARK = 'dark',
  POSITIVE = 'positive',
  NEGATIVE = 'negative',
  PRIMARY_500 = 'primary-500',
  PRIMARY_300 = 'primary-300',
  WARNING = 'warning',
  INFO = 'info'
}

export enum IconCursor {
  DEFAULT = 'default',
  POINTER = 'pointer'
}

export enum Icon {
  ACCOUNTING = 'accouting',
  ADMINISTRATOR = 'administrator',
  AI = 'artificial-intelligence',
  ARROW_RIGHT = 'arrow-right',
  BUDGET = 'budget',
  BRAIN = 'brain',
  CALENDAR = 'calendar',
  CERTIFICATE_CHECK = 'certificate-check',
  CHANGELOG = 'changelog',
  CHECK = 'check',
  CHEVRON_DOWN = 'chevron-down',
  CHEVRON_LEFT = 'chevron-left',
  COMMENT = 'comment',
  COMPANY = 'company',
  COMPANY_BRANCHES = 'company_branches',
  CRM = 'crm',
  CRM_NEW_RESPONSE = 'crm-new-response',
  CRM_EDIT_STATUS = 'crm-new-status',
  CRM_DAYS_STOPPED = 'crm-days-stopped',
  CUSTOMER = 'customer',
  DASHBOARD = 'dashboard',
  DEFAULT = 'default',
  DESCRIPTION = 'description',
  DOCUMENTATION = 'documentation',
  EVENTS = 'events',
  EXIT_EXPANSION = 'exit_expansion',
  EXPANSION = 'expansion',
  EYE = 'eye',
  FILES = 'files',
  FINANCIAL = 'financial',
  HELP = 'help',
  HOME = 'home',
  ITEM = 'item',
  LOWER_VARIATION = 'lower_variation',
  MENU = 'menu',
  MOBILE = 'mobile',
  MONEY = 'money',
  NOTIFICATION = 'notification',
  OCTALINK = 'octalink',
  PARAMETERS = 'parameters',
  PENCIL = 'pencil',
  PLAY = 'play',
  PLUS_CIRCLE = 'plus-circle',
  PUBLICATION_INSTABILITY = 'publication_instability',
  PURCHASES = 'purchases',
  REGISTER = 'register',
  REQUISITION = 'requisition',
  RH = 'rh',
  SALES = 'sales',
  SERVER = 'server',
  SETTINGS = 'settings',
  SOCKET_INTERRUPTED = 'socket-interrupted',
  STATUS = 'status',
  STOCK = 'stock',
  SUPPORT = 'support',
  SUPPLIER = 'supplier',
  TARGET = 'target',
  TAX = 'money',
  TEMPERATURE = 'temperature',
  TIMER = 'timer',
  TIMES_CIRCLE = 'times_circle',
  UPPER_VARIATION = 'upper-variation',
  USER = 'user',
  WARNING = 'warning',
  WEB = 'web',
  WHATSAPP = 'whatsapp',
  WORKFLOW = 'workflow'
}
